module.exports = __webpack_public_path__ + "media/images/board-ursheet-659b23e9.jpeg";